import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, View } from 'react-native';
import { TWCText } from '@components';

import { settingsMenuTestIDs, settingsPageTestIDs } from '@constants';
import { useContextNodeHandle, useContextReference } from '@hooks';

import { styles } from './styles';

import settingsPrivacyLegalQR from '../../../assets/settings_privacy_legal_QR.png';
import { TWCAccessibleContent } from '../../focusable/TWCAccessibleContent/TWCAccessibleContent';

const testIDPath = settingsPageTestIDs.privacyLegal;

export const SettingsPrivacyLegal: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'settingsPage.privacyLegal',
  });

  const legalMenuReference = useContextReference(settingsMenuTestIDs.privacyLegal);
  const legalMenuHandle = useContextNodeHandle(settingsMenuTestIDs.privacyLegal);

  return (
    <View style={styles.wrapper}>
      <TWCAccessibleContent
        disabledScreenreaderFocus={legalMenuReference}
        nativeID={testIDPath.settingsPrivacyLegal}
        nextFocusDown={null}
        nextFocusLeft={legalMenuHandle}
        nextFocusRight={null}
        nextFocusUp={null}
        testID={testIDPath.settingsPrivacyLegal}
      >
        <View style={styles.settingsPrivacyLegalWrapper}>
          <TWCText
            style={styles.settingsPrivacyLegalInfoText}
            testID={testIDPath.settingsPrivacyLegalInfoText}
            variant={'regularText36'}
          >
            {t('legalInfoText')}
          </TWCText>
          <TWCText
            accessibilityHint={''}
            accessibilityLabel={t('legalInfoAccessibleUrl')}
            style={styles.settingsPrivacyLegalInfoUrl}
            testID={testIDPath.settingsPrivacyLegalInfoUrl}
            variant={'regularText42Transparent'}
          >
            {t('legalInfoUrl')}
          </TWCText>
          <Image source={settingsPrivacyLegalQR} style={styles.settingsPrivacyLegalQR} />
        </View>
      </TWCAccessibleContent>
    </View>
  );
};
